export default __webpack_public_path__ + "924b145e938dcffa0e96024a98c6da7e.png";